import { FocusMonitor } from '@angular/cdk/a11y'
import { Component, ElementRef, OnDestroy, OnInit, Optional, Self } from '@angular/core'
import { FormGroupDirective, NgControl, NgForm } from '@angular/forms'
import { MatFormFieldControl } from '@angular/material/form-field'
import { ClinicService, standardizePhone } from '@mmx/shared'
import { Subscription } from 'rxjs'

import { CustomMaterialInputControlComponent } from '../custom-field'

@Component({
  selector: 'mmx-phone-field',
  templateUrl: './phone-field.component.html',
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: PhoneFieldComponent,
    },
  ],
  standalone: false,
})
export class PhoneFieldComponent
  extends CustomMaterialInputControlComponent<string>
  implements OnInit, OnDestroy
{
  preferredCountries = ['us', 'ca', 'mx']

  private statusSubscription: Subscription

  private get defaultCountry(): string {
    try {
      return this.clinicService.clinic.settings.defaultCountry ?? 'US'
    } catch (ex) {
      return 'US'
    }
  }

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    @Optional() protected parentForm: NgForm,
    @Optional() protected parentFormGroup: FormGroupDirective,
    protected fm: FocusMonitor,
    protected elRef: ElementRef,
    protected clinicService: ClinicService,
  ) {
    super(ngControl, parentForm, parentFormGroup, fm, elRef)
  }

  get shouldLabelFloat() {
    return true
  }

  ngOnInit() {
    super.ngOnInit()
  }

  ngOnDestroy() {
    this.statusSubscription?.unsubscribe()
  }

  onTextInputChange($event: Event, textInput: any): void {
    const rawString = textInput.value

    if (rawString) {
      const phone = standardizePhone(rawString)
      if (phone) {
        this.value = phone
      }
    } else {
      this.value = null
    }
  }
}
